<script>
import axios from 'axios';

export default class ClientLoginRepository {
   
    async doLogin(user){
        const baseURL = process.env.VUE_APP_API_URL;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };
        const data = {
            email: user.email,
            password: user.password
        };
        // Chama a rota de login do portal do cliente
        const response = await axios.post(baseURL + 'cliente/login', data, { headers: headers });
        return response;
    }

    async getMe(token){
        const baseURL = process.env.VUE_APP_API_URL;
        const headers = {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
        };
        const response = await axios.get(baseURL + 'cliente/me', { headers: headers });
        return response;
    }
}
</script>
